export default "__VITE_ASSET__CqAZ$Ue1__"